type PlaylistSubtitleParams = {
  id: string;
  isOwn: boolean;
  ownerName: string;
  songCount: number;
  todaysTopHitsId: string;
  visibility: "public" | "private";
};

export const formatSongCount = (count: number) =>
  `${count} ${count === 1 ? "song" : "songs"}`;

export const getLibraryPlaylistSubtitle = ({
  id,
  isOwn,
  ownerName,
  songCount,
  todaysTopHitsId,
  visibility,
}: PlaylistSubtitleParams) => {
  const count = formatSongCount(songCount);

  if (
    id.startsWith("liked_") ||
    id === "discover_daily" ||
    id === todaysTopHitsId
  ) {
    return count;
  }

  return `${isOwn ? "You" : ownerName} • ${
    visibility === "public" ? "Public" : "Private"
  } • ${count}`;
};
